export enum EvvExceptionStatusEnum {
  Pending = 1,
  Resolved = 2,
  Disputed = 3
}

export const EvvExceptionStatusOptions = [
{ id: 1, label: 'Pending' },
{ id: 2, label: 'Resolved' },
{ id: 3, label: 'Disputed' }
];
